export default __webpack_public_path__ + "static/logoalt-f0a9be2a3f658d9ecb24e9216ab2ce70.png";